/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import { injectable, inject } from 'inversify'
import { observable, action } from 'mobx'
// import { injectProperty } from '../../submodules/arc/configuration/ServiceLocator'
import { injectProperty } from '../../configuration/ServiceLocator'

import { IProductContentStateManager, IProductInfo, IArticleInfo, ISectionInfo } from './contracts'
import IProductsApiClient from '../ProductsApiClient/contracts'

@injectable()
export class ProductContentStateManager implements IProductContentStateManager {
	@observable
	productInfo: IProductInfo

	@injectProperty('IProductsApiClient')
	public productsApiClient!: IProductsApiClient

	constructor () {
		this.productInfo = {
			productName: '',
			productDescription: '',
			sectionList: [
				{
					sectionId: '',
					sectionName: '',
					articleList: [
						{
							contentItemId: '',
							displayText: '',
						} as IArticleInfo,
					],
				} as ISectionInfo,
			],
		} as IProductInfo
	}

	@action setProductInfo(productInfo: IProductInfo) {
		this.productInfo = productInfo
	}

	@action getProductInfoByProductCode(productCode: string): Promise<void> {
		return this.productsApiClient
			.getProductInfoByProductCode(productCode)
			.then(response => this.setProductInfo(response))
			.catch(error => {
				console.log(error)
				throw new Error('an error occurred when fetching the productInfo')
			})
	}
}
